import React from 'react';
import { Link } from 'react-router-dom';
import { Twitter, Linkedin, Instagram, Mail, Phone } from 'lucide-react';
import { BillvastLogo } from '../ui/BillvastLogo';
export const Footer: React.FC = () => {
  return <footer className="bg-white border-t border-gray-100 pt-16 pb-8" data-id="element-26">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-27">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-28">
          <div className="col-span-1 md:col-span-2" data-id="element-29">
            <Link to="/" className="inline-flex mb-4" data-id="element-30">
              <BillvastLogo size="md" data-id="element-31" />
            </Link>
            <p className="text-brand-text-light mb-6 max-w-sm" data-id="element-32">
              Your Finances. Premium Relief. Manage your entire financial life
              on one seamless platform.
            </p>
            <div className="flex gap-4" data-id="element-33">
              <a href="#" className="w-10 h-10 rounded-full bg-gray-50 flex items-center justify-center text-gray-500 hover:bg-brand-primary hover:text-white transition-colors" data-id="element-34">
                <Twitter size={18} data-id="element-35" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-gray-50 flex items-center justify-center text-gray-500 hover:bg-brand-primary hover:text-white transition-colors" data-id="element-36">
                <Linkedin size={18} data-id="element-37" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-gray-50 flex items-center justify-center text-gray-500 hover:bg-brand-primary hover:text-white transition-colors" data-id="element-38">
                <Instagram size={18} data-id="element-39" />
              </a>
            </div>
          </div>

          <div data-id="element-40">
            <h4 className="font-bold text-brand-text-dark mb-4" data-id="element-41">Legal</h4>
            <ul className="space-y-3" data-id="element-42">
              <li data-id="element-43">
                <a href="#" className="text-brand-text-light hover:text-brand-primary transition-colors" data-id="element-44">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-45">
                <a href="#" className="text-brand-text-light hover:text-brand-primary transition-colors" data-id="element-46">
                  Terms of Service
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-47">
            <h4 className="font-bold text-brand-text-dark mb-4" data-id="element-48">Contact</h4>
            <ul className="space-y-3" data-id="element-49">
              <li data-id="element-50">
                <a href="mailto:info@billvast.com" className="text-brand-text-light hover:text-brand-primary transition-colors flex items-center gap-2" data-id="element-51">
                  <Mail size={16} data-id="element-52" /> info@billvast.com
                </a>
              </li>
              <li data-id="element-53">
                <a href="tel:+2348070709966" className="text-brand-text-light hover:text-brand-primary transition-colors flex items-center gap-2" data-id="element-54">
                  <Phone size={16} data-id="element-55" /> +2348070709966
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-100 pt-8 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-56">
          <p className="text-brand-text-light text-sm" data-id="element-57">
            © 2026 Billvast. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
};